import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { variant } from 'styled-system';
import theme from '@adsk/alloy-react-theme';
const config = {
  breakpoints: ['40em', '52em', '64em'],
  fontSizes: [12, 14, 16, 24, 32, 48, 64, 96, 128],
  space: [0, 4, 8, 16, 12, 24, 32, 48],
  colors: theme.colors,
  typography: theme.typography
};
export const propTypes = {
  color: {
    bg: PropTypes.oneOf(Object.keys(theme.colors)),
    color: PropTypes.oneOf(Object.keys(theme.colors))
  },
  typography: {
    typography: PropTypes.oneOf(Object.keys(theme.typography))
  },
  ellipsis: {
    ellipsis: PropTypes.oneOf(['single', 'multi'])
  }
};
export const typography = variant({
  prop: 'typography',
  variants: theme.typography
});
export const ellipsis = variant({
  prop: 'ellipsis',
  variants: {
    single: theme.typography.ellipsis,
    multi: theme.typography.lineClamp
  }
});
export const base = {
  boxSizing: 'border-box',
  margin: 0,
  minWidth: 0
};
const Theme = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: config
  }, children);
};
export default Theme;
//# sourceMappingURL=Theme.js.map